import { render, staticRenderFns } from "./bindtable.vue?vue&type=template&id=24c3a3ba"
import script from "./bindtable.vue?vue&type=script&lang=js"
export * from "./bindtable.vue?vue&type=script&lang=js"
import style0 from "./bindtable.vue?vue&type=style&index=0&id=24c3a3ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports